import BaseService from "dev/packages/BaseService";
import ModuleCreator from "src/store/ModuleCreator";

const SurveyorService = Object.create(BaseService);
Object.defineProperty(SurveyorService, "className", {
	get() {
		return "surveyor";
	}
});

export const types = {};
export const params = {};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.measurement,
@property  {array}  modules.measurements
 **/

const SurveyorsModule = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types
};
export default ModuleCreator("surveyor", SurveyorService, SurveyorsModule, types, params);
